<template>
  <div class="d-flex flex-column flex-grow-1">
    <b-card class="flex-grow-1"  body-class="d-flex justify-content-around dough-counters align-items-center">
      <h3 class="mb-0" slot="header">Необходимо</h3>
      <div class="counter-wrapper">
        <h5 class="counter-wrapper__header">Традиционное тесто</h5>
        <div class="counter">
          <span class="counter__number">{{pizzaDoughsNeedsCount.big}}</span>
        </div>
      </div>
      <div class="counter-wrapper">
        <h5 class="counter-wrapper__header">Тонкое тесто</h5>
        <div class="counter counter_small">
          <span class="counter__number">{{pizzaDoughsNeedsCount.small}}</span>
        </div>
      </div>
      <div class="counter-wrapper">
        <h5 class="counter-wrapper__header">Тесто для пирога</h5>
        <div class="counter counter_small">
          <span class="counter__number">{{pizzaDoughsNeedsCount.pie}}</span>
        </div>
      </div>
    </b-card>
    <b-card class="flex-grow-1" body-class="d-flex justify-content-around dough-counters align-items-center">
      <h3 class="mb-0" slot="header">Раскатано</h3>
      <div class="counter-wrapper">
        <h5 class="counter-wrapper__header">Традиционное тесто</h5>
        <div class="counter"  @click="doughRolled(true, false)">
          <span class="counter__number">{{pizzaDoughRolledCount.big}}</span>
        </div>
      </div>
      <div class="counter-wrapper">
        <h5 class="counter-wrapper__header">Тонкое тесто</h5>
        <div class="counter counter_small" @click="doughRolled(false, false)">
          <span class="counter__number">{{pizzaDoughRolledCount.small}}</span>
        </div>
      </div>
      <div class="counter-wrapper">
        <h5 class="counter-wrapper__header">Тесто для пирога</h5>
        <div class="counter counter_small" @click="doughRolled(true, true)">
          <span class="counter__number">{{pizzaDoughRolledCount.pie}}</span>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import workshopsQueries from '../graphql/workshops'
export default {
  name: 'PizzaDoughScreen',
  data () {
    return {
      pizzaDoughsNeeds: null,
      pizzaDoughsRolled: null
    }
  },
  methods: {
    doughRolled (big, isPie) {
      this.$apollo.mutate({
        mutation: workshopsQueries.INCREASE_PIZZA_COUNT,
        variables: {
          bigSize: big,
          pie: isPie
        }
      }).then(res => {
        this.$apollo.queries.pizzaDoughsRolled.refetch()
      })
    }
  },
  computed: {
    pizzaDoughsNeedsCount () {
      if (this.pizzaDoughsNeeds === null) {
        return {
          big: 0,
          small: 0,
          pie: 0
        }
      } else {
        return this.pizzaDoughsNeeds
      }
    },
    pizzaDoughRolledCount () {
      if (this.pizzaDoughsRolled === null) {
        return {
          big: 0,
          small: 0,
          pie: 0
        }
      } else {
        return this.pizzaDoughsRolled
      }
    }
  },
  apollo: {
    pizzaDoughsNeeds: {
      query: workshopsQueries.NEED_DOUGH_COUNT,
      update (data) {
        return data.pizzaNeedDoughCount
      },
      pollInterval: 10000,
      fetchPolicy: 'network-only'
    },
    pizzaDoughsRolled: {
      query: workshopsQueries.PIZZA_DOUGH_ROLLED,
      update (data) {
        return data.pizzaDoughCount
      },
      pollInterval: 10000,
      fetchPolicy: 'network-only'
    }
  }
}
</script>

<style scoped>
  .dough-counters {
    margin: 0 100px;
  }
  .counter {
    cursor: pointer;
    display: flex;
    width: 15vw;
    height: 15vw;
    border-radius: 100%;
    box-shadow: #cccccc 0px 0px 4px 4px;
    align-items: center;
    justify-content: center;
  }
  .counter.counter_small {
    margin: 1vw;
    width: 13vw;
    height: 13vw;
  }

  .counter__number {
    font-size:40px;
  }
  .counter-wrapper__header {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/PizzaDoughScreen.vue